module.exports = __webpack_public_path__ + "img/lte.137e1f81.png";